import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';

const MAX_POLLS = 15;
const POLL_INTERVAL_MS = 2000;

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus('failed'); return; }
    let cancelled = false;
    const poll = async (n) => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (cancelled) return;
        if (res.data.payment_status === 'paid') {
          setStatus('paid');
          return;
        }
        if (n >= MAX_POLLS) { setStatus('timeout'); return; }
        setAttempts(n + 1);
        setTimeout(() => poll(n + 1), POLL_INTERVAL_MS);
      } catch {
        if (!cancelled) setStatus('failed');
      }
    };
    poll(0);
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="dashboard-container">
      <div className="payment-result-wrapper" data-testid="payment-success-page">
        {status === 'checking' && (
          <div className="payment-result-card">
            <div className="payment-spinner"><i className="fa-solid fa-circle-notch fa-spin" /></div>
            <h1>Confirming your payment…</h1>
            <p>Just a moment — Stripe is finalizing your subscription. ({attempts}/{MAX_POLLS})</p>
          </div>
        )}
        {status === 'paid' && (
          <div className="payment-result-card success" data-testid="payment-success-confirmed">
            <div className="payment-icon" style={{ background: '#16a34a' }}><i className="fa-solid fa-check" /></div>
            <h1>You're in! 🎉</h1>
            <p>Your CareGuard Family subscription is active. Head to your Family Dashboard to see today's care log.</p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', marginTop: '1.5rem', flexWrap: 'wrap' }}>
              <Link to="/family/dashboard" className="submit-button" style={{ width: 'auto', padding: '0.75rem 1.5rem' }} data-testid="success-go-family">
                Go to Family Dashboard <i className="fa-solid fa-arrow-right" />
              </Link>
              <button onClick={() => navigate('/dashboard')} className="clog-nav-btn" style={{ maxWidth: 200 }}>Back to Home</button>
            </div>
          </div>
        )}
        {status === 'timeout' && (
          <div className="payment-result-card">
            <div className="payment-icon" style={{ background: '#f59e0b' }}><i className="fa-solid fa-clock" /></div>
            <h1>Still confirming…</h1>
            <p>Stripe is taking a bit longer than usual. Your card charge (if any) will be reversed automatically if it doesn't settle. Refresh in a minute or check your email for the receipt.</p>
            <button onClick={() => window.location.reload()} className="submit-button" style={{ width: 'auto', padding: '0.6rem 1.4rem', marginTop: '1rem' }}>Refresh Status</button>
          </div>
        )}
        {status === 'failed' && (
          <div className="payment-result-card">
            <div className="payment-icon" style={{ background: '#dc2626' }}><i className="fa-solid fa-xmark" /></div>
            <h1>Something went wrong</h1>
            <p>We couldn't verify your payment. If you were charged, it will refund automatically. Please try again.</p>
            <Link to="/plans" className="submit-button" style={{ width: 'auto', padding: '0.6rem 1.4rem', marginTop: '1rem' }}>Back to Plans</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
